module.exports = __webpack_public_path__ + "img/neo-hero-image.b887212e.png";